import React from "react";

function BrandMarquee() {
  const marqueeImages = [
   `${process.env.PUBLIC_URL}/assets/videos/img2.jpg`,
   `${process.env.PUBLIC_URL}/assets/videos/img3.jpg`,
   `${process.env.PUBLIC_URL}/assets/videos/img4.jpg`,
   `${process.env.PUBLIC_URL}/assets/videos/img6.jpeg`,
   `${process.env.PUBLIC_URL}/assets/videos/img7.jpg`,
  ];

  return (
    <section className="luxury-marquee-section py-5">
      <div className="container-fluid px-0">
        
        {/* Optional Clean Small Caption Header */}
        <div className="marquee-caption-title text-center mb-4">
          <span>OUR LOOKBOOK JOURNAL</span>
        </div>

        {/* CORE MARQUEE TRACK OVERFLOW SYSTEM */}
        <div className="luxury-marquee-overflow-container">
          <div className="marquee-infinite-scroll-track">
            
            {/* FIRST UNIQUE SET LOOP */}
            <div className="marquee-images-group">
              {marqueeImages.map((imgUrl, idx) => (
                <div className="marquee-image-item-card" key={`first-${idx}`}>
                  <img src={imgUrl} alt={`Orangeapes visual track ${idx}`} className="marquee-img-asset" />
                </div>
              ))}
            </div>

            {/* 🌟 CRITICAL DUPLICATE MATCH SET: Infinite track fill layer */}
            <div className="marquee-images-group" aria-hidden="true">
              {marqueeImages.map((imgUrl, idx) => (
                <div className="marquee-image-item-card" key={`second-${idx}`}>
                  <img src={imgUrl} alt={`Orangeapes visual track clone ${idx}`} className="marquee-img-asset" />
                </div>
              ))}
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default BrandMarquee;